import React from 'react';
import RicosViewer from '../../../../ui/ricos-viewer/ricos-viewer';
import { getHeaderAndParagraphCustomStylesWUT, useRicosTheme } from '../../../../theme/ricos-theme-utils';
import { classes } from './submit-button-wut.st.css';
const RICOS_THEME = {
  customStyles: getHeaderAndParagraphCustomStylesWUT()
};
export const ThankYouMessageWUT = _ref => {
  let {
    messageText
  } = _ref;
  const customTheme = useRicosTheme(RICOS_THEME);
  if (!messageText) {
    return null;
  }
  return /*#__PURE__*/React.createElement(RicosViewer, {
    dataHook: "thank-you-message",
    content: messageText,
    customTheme: customTheme,
    className: classes.thankYouMessage
  });
};
//# sourceMappingURL=thank-you-message-wut.js.map